import { DatePipe } from '@angular/common';
import { Component, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../shared/config/app-config';
import { FormSessionCanDeactivate, PatientService, Puser, User, UserService } from '../../shared';
import { ConfirmtempComponent } from '../confirmtemp/confirmtemp.component';
import { Options } from '@angular-slider/ngx-slider';

@Component({
  selector: 'app-assement',
  templateUrl: './passement.component.html',
  styleUrls: ['./passement.component.css']
})
export class PSAssementComponent extends FormSessionCanDeactivate {
  enddate: string;
  startdate: string;
  maxdate: boolean;
  togglepattern: any;
  showinvaild: boolean;
  pattern: any;
  public name: any;
  resp: any;
  survey: any;
  mulans: any;
  option: any;
  enable: boolean = false;
  enableques: boolean = false;
  public surveydate: any = {};
  timeset: any = environment.timelimit
  apiurl: any = environment.api_url
  pathid: any;
  surveyques: any;
  intro: any;
  padding: any;
  ques: any;
  anstype: any;
  inner: any;
  inneransvalue: any;
  savesurvey: any;
  answer: any = [];
  public inputsurvey: any = {};
  ansvalue: any;
  modalRef: BsModalRef;
  ans: any;
  assigned: any;
  slideval: any;
  result: any;
  number: any;
  type: any;
  user: any;
  complete = false;
  enablepage = false;
  public object: any;
  CurrentUser: User;
  PUser: Puser;
  public bobMaxDate = new Date();
  public dateformat = environment.dateFormat;
  public bsConfig: any
  private subscription: Subscription;
  private timer: Observable<any>;
  public imageURL: string = environment.cloudeImageURL;
  introonly: boolean;
  previousintro: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private userService: UserService,
    private patientService: PatientService,
    private dialog: MatDialog,
    private datepipe: DatePipe
  ) {
    super();
  }
  ngOnInit() {
    this.name = JSON.parse(atob(window.localStorage['surveyData']))
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
            this.dateformat = environment.dateFormat;
          } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
            this.dateformat = 'DD/MM/YYYY'
          }
          this.bsConfig = Object.assign({}, { containerClass: 'theme-dark-blue', showWeekNumbers: false, dateInputFormat: this.dateformat });
        }
      }
    )
    if (this.CurrentUser.item.hostModel == "CLOUD")
      this.imageURL = environment.cloudeImageURL;
    else
      this.imageURL = environment.vmImageURL;

    //////console.log(this.route.snapshot.url[0].path)

    this.userService.PUser.subscribe(
      (puserData) => {
        this.resp = puserData;
        this.PUser = puserData;

      }
    )
    this.getUserDetails()
    this.userService
      .getactivity(this.name.swfid)
      .subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].data.length; j++) {
              if (data[i].data[j].materialHspPatientMappingId == this.name.name) {
                this.pathid = data[i].data[j].materialId;
              }

            }
          }

        }

      );
    /* this.userService.getassignedbydetails(this.name.materialId, 'survey')
      .subscribe(
        data => {

          this.assigned = data
          //////console.log(data)
          if (this.route.snapshot.url[0].path == 'assessment') {
            this.CurrentUser.operationStatus = 'material'
            if (this.assigned.userRole == 'Care Coordinator' || this.assigned.userRole == 'Care Outcomes Manager')
              var userole = 'Care Navigator'
            this.CurrentUser.operationMessage = 'Assigned by&nbsp;:&nbsp;<img class="rounded-circle pl" title="' + this.assigned.name + '" src="' + this.apiurl + this.assigned.userImagePath + '"> &nbsp;' + this.assigned.name + '&nbsp;|&nbsp;' + userole
          }
        }); */

    if (this.name.name) {
      this.userService
        .getsurvey(this.name.name, this.name.swfid, this.name.type)
        .subscribe(
          data => {
            this.survey = data;
            this.enablepage = true;
            if (data) {
              this.result = data[1].result;

              this.surveyques = data[0].survey;
              if (this.surveyques.name.search('Recovery Goals') != -1)
                this.introonly = false
              else
                this.introonly = true
              //this.number = data[0].survey.sQuestion.length;
              this.number = 0
              data[0].survey.sQuestion.forEach(element => {
                if (element.active == '1')
                  this.number = this.number + 1
              });
              if (this.number == 1)
                this.complete = true;
              let index = 0
              for (var g = 0; g < data[1].result.length; g++) {
                if ((data[1].result[g].resultAnswerType.toLowerCase() == 'single' && data[1].result[g].resultChoicetypeId == "" && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'textbox' && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped) || ((data[1].result[g].resultAnswerType.toLowerCase() == 'sliderbar' || data[1].result[g].resultAnswerType.toLowerCase() == 'c_sliderbar' || data[1].result[g].resultAnswerType.toLowerCase() == 'slider') && (data[1].result[g].resultAnswerValue == "null" || data[1].result[g].resultAnswerValue == "") && !data[1].result[g].resultIsSkipped)) {
                  index = g
                  break;
                } else if (((data[1].result[g].resultAnswerType.toLowerCase() == 'multiplercsd' || data[1].result[g].resultAnswerType.toLowerCase() == 'multiple') && data[1].result[g].multiResult && !data[1].result[g].resultIsSkipped) || (data[1].result[g].resultAnswerType.toLowerCase() == 'singlenewyn' && data[1].result[g].multiResult && !data[1].result[g].resultIsSkipped)) {
                  let ind = _.findIndex(data[1].result[g].multiResult, (o: any): any => {
                    return o.mulAnswerValue != "null"
                  })
                  if (ind == -1) {
                    index = g
                    break;
                  }
                }
              }
              if (this.name.patedit != 'new') {
                index = 0
              }
              if (index == 0)
                this.intro = data[0].survey.introduction;
              if (this.number - 1 == index)
                this.complete = true;
              this.ques = data[0].survey.sQuestion[index];
              if (this.ques) {
                if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                  this.padding = '13px'
                else
                  this.padding = '68px'
                if ((this.ques.questiontype.toLowerCase()) == 'single') {
                  this.complete = false;
                  if (this.getresult(this.result, this.ques).resultChoicetypeId != 0)
                    this.option = true
                }
                if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                  this.complete = false;
                  if (this.getresult(this.result, this.ques).resultChoicetypeId != 0)
                    this.option = true
                }
                this.ans = data[0].survey.sQuestion[index].sAnswer;
                for (var g = 0; g < data[1].result.length; g++) {
                  if (data[1].result[g].resultAnswerValue == 'null' && data[0].survey.sQuestion[g].questiontype.toLowerCase().includes('slider')) {
                    data[1].result[g].resultAnswerValue = "0"
                  }
                }
                if (this.ans.innerChoice) {
                  this.inner = this.ans.innerChoice
                  this.inneransvalue = this.getresult(this.result, this.ques).InnerResult
                }
                this.ansvalue = this.getresult(this.result, this.ques);
                let input;
                var answer
                if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                  if (this.ansvalue.resultAnswerValue != 'null') {
                    answer = this.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'height': answer[0],
                      'feet': answer[2]
                    }
                  }
                  else {
                    input = {
                      'height': '',
                      'feet': ''
                    }
                  }
                }
                else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                  if (this.ansvalue.resultAnswerValue != 'null') {
                    answer = this.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'input': answer[0]
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                else {
                  if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                    input = {
                      'input': this.ansvalue.resultAnswerValue
                    }
                  } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                    input = {
                      'input': new Date(this.ansvalue.resultAnswerValue)
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                this.inputsurvey = input; ////console.log(this.inputsurvey)
                //////console.log(this.inputsurvey)

              }



            }


          }

        );
    }

    this.getSurveyDete();
    if (this.name.patedit == 'new') {
      let ccresult = this.dialog.open(ConfirmtempComponent, { hasBackdrop: true, disableClose: true });
      ccresult.componentInstance.catId = this.name.todocategoryid;
      ccresult.componentInstance.patSurveyId = this.name.name;
      ccresult.componentInstance.patact = this.name.patact;
      ccresult.componentInstance.clientId = parseInt(this.CurrentUser.item.userAccountKey);
      ccresult.componentInstance.loginUserId = this.CurrentUser.item.userAccountId;
      ccresult.afterClosed().subscribe(result => {


        ccresult.close();

        //  alert(result);




      });
    }

  }
  surveyccviewed() {
    let self = this;
    let startdate, enddate;
    startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    this.startdate = window.localStorage['startdate'] ? window.localStorage['startdate'] : 'N';
    this.enddate = window.localStorage['enddate'] ? window.localStorage['enddate'] : 'N';
    self.patientService.updateccviewd(window.localStorage['patid'], self.name.name, self.name.surveyname, self.name.todocategoryid, self.name.careplansurveyid, startdate, enddate)
      .subscribe(data => {
        ////console.log(data)
        this.userService.logAudit('updateDashboardCarePlanTodoAfterCcViewed', 0).subscribe(data => { })
        self.surveydate = data;
      })
    /*  self.patientService.updateccreviewd(window.localStorage['patid'], self.name.name, self.name.surveyname, self.name.todocategoryid)
        .subscribe(data=>{
        ////console.log(data)
        let surveydate = data;
        }) */
  }
  getSurveyDete() {
    let self = this;
    self.patientService.getSurveyDetailsbySurevydate(self.name.name)
      .subscribe(data => {
        ////console.log(data)
        self.surveydate = data;
      })
  }
  getid(id) {
    if (id == 1083) {
      return true
    }
    else {
      return false
    }
  }
  getidinner(ques) {
    if (ques.toLowerCase() == this.userService.translateText('patient_portal.question.steps_to_enter_your_home') || ques.toLowerCase() == this.userService.translateText('patient_portal.question.inside_home_stairs') || ques.toLowerCase() == this.userService.translateText('patient_portal.question.phone_no_support_person')) {
      return true
    }
    else {
      return false
    }
  }
  checkvalid(value) {
    if (value == 0) {
      this.toastr.warning(this.userService.translateText('patient_portal.assessment.min_value_is_greater.label'))
      this.inneransvalue['How many steps to enter your home?'] = ""
    }
  }
  checknumvalid(value) {
    if (value == 0) {
      //this.toastr.warning('Minimum value is greater than 0')
      this.inputsurvey.input = ""
    }
  }
  getphid(ques) {
    if (ques.toLowerCase() == 'phone number of your support person') {
      return true
    }
    else {
      return false
    }
  }
  getUserDetails() {
    let self = this;
    self.patientService.getSuveryUserDetais(self.name.patid, self.name.swfid)
      .subscribe(data => {
        if (Array.isArray(data) && data.length)
          self.user = data[0]
      })
  }
  nextsingleques(anstype, m, innerchoice, event) {
    setTimeout(() => {
      this.nextSQues(anstype, m, innerchoice, event)
    }, 300)
  }
  nextSQues(anstype, m, innerchoice, event) {
    this.option = false

    if (event) {
      //////console.log(anstype.ansChoicetypeId)
      if (event != 'y') {
        event = 0
      }
      else {
        event = 1
      }
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        var result = this.getresult(this.result, this.ques)

        for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
          if (this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == this.userService.translateText('hospital_portal.profile.none.label') || this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == "I did not experience any of these complications") {
            this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue = "null"
            this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId = 0
            this.getresult(this.result, this.ques).multiResult[j].mulScoreValue = "null"
          }
        }

        this.getresult(this.result, this.ques).multiResult[m].mulAnswerValue = anstype.choicetype
        if (event == 1) {
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = anstype.ansChoicetypeId
        }
        else {
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = 0
        }
        this.getresult(this.result, this.ques).multiResult[m].mulScoreValue = event
        this.getresult(this.result, this.ques).resultIsSkipped = false
        if (!anstype.innerChoice) {
          for (var s = 0; s < this.getresult(this.result, this.ques).InnerResult.length; s++) {
            this.getresult(this.result, this.ques).InnerResult[s].innerAnswerValue = "null"
          }
        }
      }


      if (anstype.innerChoice) {
        this.inner = anstype.innerChoice
        this.anstype = anstype
        if (result.InnerResult[0]) {
          this.inneransvalue = result.InnerResult
          // Initialize enableques to false by default
          this.enableques = false
          // Initialize innerAnswerValue as object for textbox types
          for (let i = 0; i < this.inneransvalue.length; i++) {
            if (this.inner[i] && this.inner[i].innerQuestionType && this.inner[i].innerQuestionType.toLowerCase() === 'textbox') {
              if (typeof this.inneransvalue[i].innerAnswerValue === 'string' && (this.inneransvalue[i].innerAnswerValue === 'null' || this.inneransvalue[i].innerAnswerValue === '')) {
                this.inneransvalue[i].innerAnswerValue = {}
              } else if (typeof this.inneransvalue[i].innerAnswerValue === 'string') {
                // Try to parse if it's a JSON string
                try {
                  this.inneransvalue[i].innerAnswerValue = JSON.parse(this.inneransvalue[i].innerAnswerValue)
                } catch (e) {
                  this.inneransvalue[i].innerAnswerValue = {}
                }
              }
            }
            
            // Initialize enableques based on existing answers for conditional questions
            if (this.inner[i + 1] && (this.inner[i + 1].innerChoicePk == 25 || this.inner[i + 1].innerChoicePk == 28 || this.inner[i + 1].innerChoicePk == 31 || this.inner[i + 1].innerChoicePk == 34)) {
              const currentAnswer = this.inneransvalue[i].innerAnswerValue;
              if (typeof currentAnswer === 'string' && currentAnswer.toLowerCase() === this.userService.translateText('hospital_portal.mytodos.yes_small.label')) {
                this.enableques = true
              }
            }
          }
        }
        //////console.log(this.inner)

        this.modalRef = this.modalService.show(innerchoice, { backdrop: 'static' });
        this.movable()
      }
    }


  }
  nextSingleQues(id, popup: TemplateRef<any>) {
    this.option = false
    this.mulans = false;
    var ans;
    let index = _.findIndex(this.result[id - 1].multiResult, (o: any): any => {
      return o.mulAnswerValue == "null"
    })
    if (index == -1) {
      let number: string = id;
      //let num: number = this.ques.questionId;


      ////////console.log(this.answer);



      ////////console.log(this.result)
      ////////console.log(number)
      if (this.name.type != 2) {
        this.userService
          .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
          .subscribe(
            data => {
              this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
            }

          );
      }
      if (number >= this.number) {
        this.complete = true;
        this.completesurvey(popup);

      }
      else {
        id = id + 1;


        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {

          for (var l = 0; l < this.ans.length; l++) {
            if (this.ans[l].ForwardSkipQusId != null) {

              ans = this.ans[l].ForwardSkipQusId
            }
          }
          if (ans == "" || !ans) {
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ans = [];
              this.ques = [];
              this.intro = null;
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'single')
                this.complete = false
              this.mulans = null;
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
                this.complete = false
              this.mulans = null;
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = [];
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              let input, answer;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; ////console.log(this.inputsurvey)
              break;
            }
          }
          else if (ans == this.survey[0].survey.sQuestion[j].questionId) {
            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (ans == forwardid) {
                //var temp = t;
                break;
              }


            }
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = [];
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input, answer;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; ////console.log(this.inputsurvey)
            break;
          }
          if (number + 1 >= this.number)
            this.complete = true;


        }

      }
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_answer_all_question.error'));
    }

  }
  rdisabled: boolean
  nextques(id, anstype, innerchoice, popup) {
    this.rdisabled = true
    let number: string = id;
    if (number >= this.number) {
      this.enablepage = false;
    }
    setTimeout(() => {
      this.nextQues(id, anstype, innerchoice, popup)
    }, 300)
  }
  nextQues(id, anstype, innerchoice, popup) {
    var ans
    this.option = false
    if (anstype) {
      let number: string = id;
      //let num: number = this.ques.questionId;
      if (this.surveyques.branchPattern) {
        this.togglepattern = this.surveyques.branchPattern.split('~BR~');
        for (var f = 0; f < this.togglepattern.length; f++) {
          if (this.togglepattern[f].includes('TOGGLE###qpk')) {
            this.pattern = this.togglepattern[f].split('|');
            if (this.pattern[1])
              var branchques = this.pattern[1].split('_')
            if (branchques[0] == this.ques.questionId) {
              if (this.pattern[2]) {
                ans = this.pattern[2].split('#')
                if (ans[0].includes('^')) {
                  ans = ans[0].split('^')
                  ans.forEach(ansItem => {
                    if (ansItem == anstype.ansChoicetypeId) {
                      number = this.number
                      this.getresult(this.result, this.ques).resultIsSkipped = true
                      this.getresult(this.result, this.ques).resultAnswerValue = ''
                      for (var qs = id; qs < this.result.length; qs++) {
                        this.result[qs].resultAnswerValue = ''
                        this.result[qs].InnerResult = [];
                        this.result[qs].multiResult = [];
                        this.result[qs].resultAnswerId = 0
                        this.result[qs].resultChoicetypeId = 0
                        this.result[qs].resultScoreValue = ''
                      }
                    }
                  })
                } else {
                  if (ans[0] == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                }

              }
            }
          }
        }
      }
      this.answer[id] = anstype
      var showloader = true;

      ////////console.log(this.answer);
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).resultAnswerId = anstype.scoreId ? anstype.scoreId : 0
        this.getresult(this.result, this.ques).resultAnswerValue = anstype.score_value
        this.getresult(this.result, this.ques).resultChoicetypeId = anstype.ansChoicetypeId
        this.getresult(this.result, this.ques).resultScoreValue = anstype.score_value
        var result = this.getresult(this.result, this.ques)
        this.getresult(this.result, this.ques).resultIsSkipped = false
        if (!anstype.innerChoice) {
          for (var s = 0; s < this.getresult(this.result, this.ques).InnerResult.length; s++) {
            this.getresult(this.result, this.ques).InnerResult[s].innerAnswerValue = "null"
          }
        }

      }
      if (this.name.type != 2) {
        this.userService
          .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
          .subscribe(
            data => {
              this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
            }

          );
      }


      if (number >= this.number) {
        this.enablepage = false;
        this.completesurvey(popup)
      }
      else if (anstype.innerChoice) {
        this.enablepage = true;
        this.anstype = anstype;
        this.inner = anstype.innerChoice
        if (result.InnerResult[0]) {
          this.inneransvalue = result.InnerResult
          // Initialize enableques to false by default
          this.enableques = false
          // Initialize innerAnswerValue as object for textbox types
          for (let i = 0; i < this.inneransvalue.length; i++) {
            if (this.inner[i] && this.inner[i].innerQuestionType && this.inner[i].innerQuestionType.toLowerCase() === 'textbox') {
              if (typeof this.inneransvalue[i].innerAnswerValue === 'string' && (this.inneransvalue[i].innerAnswerValue === 'null' || this.inneransvalue[i].innerAnswerValue === '')) {
                this.inneransvalue[i].innerAnswerValue = {}
              } else if (typeof this.inneransvalue[i].innerAnswerValue === 'string') {
                // Try to parse if it's a JSON string
                try {
                  this.inneransvalue[i].innerAnswerValue = JSON.parse(this.inneransvalue[i].innerAnswerValue)
                } catch (e) {
                  this.inneransvalue[i].innerAnswerValue = {}
                }
              }
            }
            
            // Initialize enableques based on existing answers for conditional questions
            if (this.inner[i + 1] && (this.inner[i + 1].innerChoicePk == 25 || this.inner[i + 1].innerChoicePk == 28 || this.inner[i + 1].innerChoicePk == 31 || this.inner[i + 1].innerChoicePk == 34)) {
              const currentAnswer = this.inneransvalue[i].innerAnswerValue;
              if (typeof currentAnswer === 'string' && currentAnswer.toLowerCase() === this.userService.translateText('hospital_portal.mytodos.yes_small.label')) {
                this.enableques = true
              }
            }
          }
        }
        this.modalRef = this.modalService.show(innerchoice, { backdrop: 'static' });
        this.movable()
      }
      else {
        id = id + 1;

        if (id >= this.number) {
          this.complete = true
        }
        this.enablepage = true;
        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
          if (anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
                this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              let input, answer;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; ////console.log(this.inputsurvey)
              break;
            }
          }
          else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {

            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (anstype.ForwardSkipQusId == forwardid) {
                break;
              }

            }
            this.ans = [];
            this.ques = [];
            this.intro = null;

            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            let input, answer;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; ////console.log(this.inputsurvey)
            break;
          }
        }



      }
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_select_any_one.error'));
    }
    this.rdisabled = false
  }

  isInnerTextboxComplete(): boolean {
    // Check if ALL visible inner questions are answered (both textbox and radio types)
    if (!this.inner || !this.inneransvalue) {
      return false;
    }
    
    // Check each inner question
    for (let i = 0; i < this.inner.length; i++) {
      const innerGroup = this.inner[i];
      const innerValue = this.inneransvalue[i];
      
      if (!innerGroup || !innerValue) {
        return false;
      }
      
      // Skip validation for conditional questions that are hidden
      // Questions with innerChoicePk 25, 28, 31, 34 are conditional and shown only when enableques is true
      const isConditionalQuestion = innerGroup.innerChoicePk && [25, 28, 31, 34].includes(innerGroup.innerChoicePk);
      if (isConditionalQuestion && !this.enableques) {
        // This question is hidden, skip validation
        continue;
      }
      
      // For textbox type questions
      if (innerGroup.innerQuestionType && innerGroup.innerQuestionType.toLowerCase() === 'textbox') {
        const innerValueObj : any = innerValue.innerAnswerValue;
        
        
        // Check if all textbox fields have values
        if (innerGroup.innerAnsChNameArray) {
          const allTextboxesFilled = innerGroup.innerAnsChNameArray.every(ans => {
            const value = typeof innerValueObj == "string" ? innerValueObj : [ans.innerAnsChName];
            return this.isInnerAnswerFilled(value);
          });
          
          if (!allTextboxesFilled) {
            return false;
          }
        }
      }
      // For radio type questions
      else if (innerGroup.innerQuestionType && innerGroup.innerQuestionType.toLowerCase() === 'radio') {
        // Check if an answer is selected (innerAnswerValue should not be "null" or empty)
        if (!this.isInnerAnswerFilled(innerValue.innerAnswerValue)) {
          return false;
        }
      }
    }
    
    return true;
  }

  isInnerAnswerFilled(value: any): boolean {
    if (value === null || value === undefined) {
      return false;
    }
    if (typeof value === 'string') {
      const normalized = value.trim();
      if (normalized === '' || normalized.toLowerCase() === 'null') {
        return false;
      }
    }
    return true;
  }

  nextSingle(id, popup: TemplateRef<any>) {
    this.option = false
    let number: string = id;
    var ans
    //let num: number = this.ques.questionId;
    if (this.surveyques.branchPattern) {
      this.togglepattern = this.surveyques.branchPattern.split('~BR~');
      for (var f = 0; f < this.togglepattern.length; f++) {
        if (this.togglepattern[f].includes('TOGGLE###qpk')) {
          this.pattern = this.togglepattern[f].split('|');
          if (this.pattern[1])
            var branchques = this.pattern[1].split('_')
          if (branchques[0] == this.ques.questionId) {
            if (this.pattern[2]) {
              ans = this.pattern[2].split('#')
              if (ans[0].includes('^')) {
                ans = ans[0].split('^')
                ans.forEach(ansItem => {
                  if (ansItem == this.answer[id].ansChoicetypeId) {
                    number = this.number
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                })
              } else {
                if (ans[0] == this.answer[id].ansChoicetypeId) {
                  number = this.number
                  for (var qs = id; qs < this.result.length; qs++) {
                    this.result[qs].resultAnswerValue = ''
                    this.result[qs].InnerResult = [];
                    this.result[qs].multiResult = [];
                    this.result[qs].resultAnswerId = 0
                    this.result[qs].resultChoicetypeId = 0
                    this.result[qs].resultScoreValue = ''
                  }
                }
              }

            }
          }
        }
      }
    }

    ////////console.log(this.answer);



    ////////console.log(this.result)
    ////////console.log(number)

    if (number >= this.number) {
      this.complete = true;
      this.completesurvey(popup);

    }
    else {
      id = id + 1;


      for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {

        for (var l = 0; l < this.ans.length; l++) {
          if (this.ans[l].ForwardSkipQusId != null) {

            ans = this.ans[l].ForwardSkipQusId
          }
        }
        if (ans == "" || !ans) {
          if (id == this.survey[0].survey.sQuestion[j].qNumber) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            this.mulans = null;
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            this.mulans = null;
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = [];
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            let input, answer;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; ////console.log(this.inputsurvey)
            break;
          }
        }
        else if (ans == this.survey[0].survey.sQuestion[j].questionId) {
          let forwardid = this.ques.questionId + 1
          for (var t = 0; t < this.result.length; t++) {
            if (this.result[t].resultQuestionId == forwardid) {
              this.result[t].resultIsSkipped = true
              this.result[t].resultAnswerValue = ''
              forwardid = forwardid + 1
            }
            if (ans == forwardid) {
              //var temp = t;
              break;
            }


          }
          this.ans = [];
          this.ques = [];
          this.intro = null;
          this.ques = this.survey[0].survey.sQuestion[j];
          if ((this.ques.questiontype.toLowerCase()) == 'single')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
            this.padding = '13px'
          else
            this.padding = '68px'
          this.ans = [];
          this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
          if (this.ans.innerChoice) {
            this.inner = this.ans.innerChoice
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
          }
          this.ansvalue = this.getresult(this.result, this.ques);
          if ((this.ques.questiontype.toLowerCase()) == 'single') {
            this.complete = false
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          let input, answer;
          if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'height': answer[0],
                'feet': answer[2]
              }
            }
            else {
              input = {
                'height': '',
                'feet': ''
              }
            }
          }
          else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'input': answer[0]
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          else {
            if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
              input = {
                'input': this.ansvalue.resultAnswerValue
              }
            } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
              input = {
                'input': new Date(this.ansvalue.resultAnswerValue)
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          this.inputsurvey = input; ////console.log(this.inputsurvey)
          break;
        }
        if (number + 1 >= this.number)
          this.complete = true;


      }

    }


  }

  nextinnerques(anstype, i, popup) {

    setTimeout(() => {
      this.nextInnerQues(anstype, i, popup)
    }, 300)
  }
  nextInnerQues(anstype, i, popup) {
    let id = this.ques.qNumber;
    let number: number = this.ques.qNumber;
    var ans
    if (anstype) {
      if (this.surveyques.branchPattern) {
        this.togglepattern = this.surveyques.branchPattern.split('~BR~');
        for (var f = 0; f < this.togglepattern.length; f++) {
          if (this.togglepattern[f].includes('TOGGLE###qpk')) {
            this.pattern = this.togglepattern[f].split('|');
            if (this.pattern[1])
              var branchques = this.pattern[1].split('_')
            if (branchques[0] == this.ques.questionId) {
              if (this.pattern[2]) {
                ans = this.pattern[2].split('#')
                if (ans[0].includes('^')) {
                  ans = ans[0].split('^')
                  ans.forEach(ansItem => {
                    if (ansItem == anstype.ansChoicetypeId) {
                      number = this.number
                      this.getresult(this.result, this.ques).resultIsSkipped = true
                      this.getresult(this.result, this.ques).resultAnswerValue = ''
                      for (var qs = id; qs < this.result.length; qs++) {
                        this.result[qs].resultAnswerValue = ''
                        this.result[qs].InnerResult = [];
                        this.result[qs].multiResult = [];
                        this.result[qs].resultAnswerId = 0
                        this.result[qs].resultChoicetypeId = 0
                        this.result[qs].resultScoreValue = ''
                      }
                    }
                  })
                } else {
                  if (ans[0] == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                }

              }
            }
          }
        }
      }
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).InnerResult[i] = {
          'innerChoicePk': this.inner[i].innerChoicePk,
          'innerQuestionType': this.inner[i].innerQuestionType,
          'innerAnswerValue': anstype.innerAnsChName
        }
        if (this.inner[i + 1]) {
          if ((this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name1') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name2') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name3') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name4')) && anstype.innerAnsChName.toLowerCase() == this.userService.translateText('hospital_portal.mytodos.yes_small.label')) {
            this.enableques = true
          }
          else if ((this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name1') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name2') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name3') || this.inner[i + 1].innerQuestionName == this.userService.translateText('patient_portal.question.innerquestion_name4')) && anstype.innerAnsChName.toLowerCase() == this.userService.translateText('hospital_portal.mytodos.no_small.label')) {
            this.enableques = false
            this.getresult(this.result, this.ques).InnerResult[i + 1] = {
              'innerChoicePk': this.inner[i].innerChoicePk,
              'innerQuestionType': this.inner[i].innerQuestionType,
              'innerAnswerValue': "null"
            }
          }
        }

      }

      if (this.inner.length <= 1) {
        this.modalRef.hide();
        if (this.name.type != 2) {
          this.userService
            .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
            .subscribe(
              data => {
                this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
              }

            );
        }
        if (number >= this.number) {
          this.completesurvey(popup)
        }
        else {
          id = id + 1;



          for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {


            if (anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) {
              this.ans = [];
              this.ques = [];
              this.intro = null;
              if (id == this.survey[0].survey.sQuestion[j].qNumber) {
                this.ques = this.survey[0].survey.sQuestion[j];
                if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                  this.padding = '13px'
                else
                  this.padding = '68px'
                this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
                if (this.ans.innerChoice) {
                  this.inner = this.ans.innerChoice
                  this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
                }
                this.ansvalue = this.getresult(this.result, this.ques);
                if ((this.ques.questiontype.toLowerCase()) == 'single') {
                  this.complete = false
                  if (this.ansvalue.resultChoicetypeId != 0)
                    this.option = true
                }
                if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                  if (this.ansvalue.resultChoicetypeId != 0)
                    this.option = true
                }
                let input, answer;
                if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                  if (this.ansvalue.resultAnswerValue != 'null') {
                    answer = this.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'height': answer[0],
                      'feet': answer[2]
                    }
                  }
                  else {
                    input = {
                      'height': '',
                      'feet': ''
                    }
                  }
                }
                else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                  if (this.ansvalue.resultAnswerValue != 'null') {
                    answer = this.ansvalue.resultAnswerValue.split(' ');
                    input = {
                      'input': answer[0]
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                else {
                  if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                    input = {
                      'input': this.ansvalue.resultAnswerValue
                    }
                  } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                    input = {
                      'input': new Date(this.ansvalue.resultAnswerValue)
                    }
                  }
                  else {
                    input = {
                      'input': ''
                    }
                  }
                }
                this.inputsurvey = input; ////console.log(this.inputsurvey)
                break;
              }
            }
            else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {

              let forwardid = this.ques.questionId + 1
              for (var t = 0; t < this.result.length; t++) {
                if (this.result[t].resultQuestionId == forwardid) {
                  this.result[t].resultIsSkipped = true
                  this.result[t].resultAnswerValue = ''
                  forwardid = forwardid + 1
                }
                if (anstype.ForwardSkipQusId == forwardid) {
                  break;
                }

              }
              this.ans = [];
              this.ques = [];
              this.intro = null;

              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              let input, answer;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; ////console.log(this.inputsurvey)
              break;
            }
          }



        }
      }

    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_select_any_one.error'));
    }
  }
  close_reset() {
    this.modalRef.hide()
    this.getresult(this.result, this.ques).resultAnswerValue = ''
    for (var k = 0; k < this.getresult(this.result, this.ques).InnerResult.length; k++) {
      this.getresult(this.result, this.ques).InnerResult[k].innerAnswerValue = "null"
    }
    this.getresult(this.result, this.ques).multiResult = [];
    this.getresult(this.result, this.ques).resultAnswerId = 0
    this.getresult(this.result, this.ques).resultChoicetypeId = 0
    this.getresult(this.result, this.ques).resultScoreValue = ''
    this.userService
      .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
      .subscribe(
        data => {
          this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
        }

      );
  }
  nextinputInnerQues(p, anstype, popup) {
    var ans;
    this.mulans = false;
    if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
      for (var k = 0; k < this.getresult(this.result, this.ques).InnerResult.length; k++) {
        if ((this.getresult(this.result, this.ques).InnerResult[k].innerAnswerValue == "null") && this.getresult(this.result, this.ques).InnerResult[k].innerQuestionType.toLowerCase() == 'radio') {
          if (k == 1)
            this.mulans = false
          if ((k > 1 && this.getresult(this.result, this.ques).InnerResult[k - 1].innerAnswerValue.toLowerCase() == "yes" && this.getresult(this.result, this.ques).InnerResult[k].innerAnswerValue == "null"))
            this.mulans = false

        }
        else {
          this.mulans = true
        }

      }
    }
    let id = this.ques.qNumber;
    let number: number = this.ques.qNumber;
    if (this.surveyques.branchPattern) {
      this.togglepattern = this.surveyques.branchPattern.split('~BR~');
      for (var f = 0; f < this.togglepattern.length; f++) {
        if (this.togglepattern[f].includes('TOGGLE###qpk')) {
          this.pattern = this.togglepattern[f].split('|');
          if (this.pattern[1])
            var branchques = this.pattern[1].split('_')
          if (branchques[0] == this.ques.questionId) {
            if (this.pattern[2]) {
              ans = this.pattern[2].split('#')
              if (ans[0] == anstype.ansChoicetypeId) {
                number = this.number
                this.getresult(this.result, this.ques).resultIsSkipped = true
                this.getresult(this.result, this.ques).resultAnswerValue = ''
                for (var qs = id; qs < this.result.length; qs++) {
                  this.result[qs].resultAnswerValue = ''
                  this.result[qs].InnerResult = [];
                  this.result[qs].multiResult = [];
                  this.result[qs].resultAnswerId = 0
                  this.result[qs].resultChoicetypeId = 0
                  this.result[qs].resultScoreValue = ''
                }
              }
            }
          }
        }
      }
    }
    if (p.value && this.mulans) {
      this.enableques = false
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        for (var klen = 0; klen < this.getresult(this.result, this.ques).InnerResult.length; klen++) {
          if (this.inner[klen].innerQuestionType.toLowerCase() == 'textbox')
            this.getresult(this.result, this.ques).InnerResult[klen] = {
              'innerChoicePk': this.inner[klen].innerChoicePk,
              'innerQuestionType': this.inner[klen].innerQuestionType,
              'innerAnswerValue': p.value
            }
        }
      }
      if (this.name.type != 2) {
        this.userService
          .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
          .subscribe(
            data => {
              this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
            }

          );
      }
      if (number >= this.number) {
        this.complete = true;
        this.completesurvey(popup)
      }
      else {
        id = id + 1;

        for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
          var value = false;
          if (this.ques.quesion = "<b>Home Environment:  Interior</b>:<br>How many stairs are in your home that you need to climb?") {

            if (p.value.input == "" || p.value.input == "No" || p.value.input == "no" || p.value.input == "0" || p.value.input == "Zero" || p.value.input == "ZERO") {
              value = true;
            }
          }

          if ((anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) || !value) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            if (id == this.survey[0].survey.sQuestion[j].qNumber) {
              this.ques = this.survey[0].survey.sQuestion[j];
              if ((this.ques.questiontype.toLowerCase()) == 'single')
                this.complete = false
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
                this.complete = false
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              //this.inneransvalue = this.result[id - 1].InnerResult;
              //////console.log(this.ansvalue)
              let input, answer;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }

              this.inputsurvey = input; ////console.log(this.inputsurvey)
              //////console.log(this.inputsurvey)

              break;
            }
          }
          else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {
            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (anstype.ForwardSkipQusId == forwardid) {
                //var temp = t;
                break;
              }

            }
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input = {
              'input': this.ansvalue.resultAnswerValue
            }
            this.inputsurvey = input; ////console.log(this.inputsurvey)
            //////console.log(this.inputsurvey)
            break;
          }
          if (number + 1 >= this.number)
            this.complete = true;
        }



      }
      this.modalRef.hide();
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.select_all_answer.error'));
    }
  }
  nextinputques(p, id, anstype, popup: TemplateRef<any>, innerchoice) {
    this.option = false
    var ans;
    let number: string = id;
    let num: number = this.ques.questionId;
    this.answer[id] = anstype;
    if (this.surveyques.branchPattern) {
      this.togglepattern = this.surveyques.branchPattern.split('~BR~');
      for (var f = 0; f < this.togglepattern.length; f++) {
        if (this.togglepattern[f].includes('TOGGLE###qpk')) {
          this.pattern = this.togglepattern[f].split('|');
          if (this.pattern[1])
            var branchques = this.pattern[1].split('_')
          if (branchques[0] == this.ques.questionId) {
            if (this.pattern[2]) {
              ans = this.pattern[2].split('#')
              if (ans[0].includes('^')) {
                ans = ans[0].split('^')
                ans.forEach(ansItem => {
                  if (ansItem == anstype.ansChoicetypeId) {
                    number = this.number
                    this.getresult(this.result, this.ques).resultIsSkipped = true
                    this.getresult(this.result, this.ques).resultAnswerValue = ''
                    for (var qs = id; qs < this.result.length; qs++) {
                      this.result[qs].resultAnswerValue = ''
                      this.result[qs].InnerResult = [];
                      this.result[qs].multiResult = [];
                      this.result[qs].resultAnswerId = 0
                      this.result[qs].resultChoicetypeId = 0
                      this.result[qs].resultScoreValue = ''
                    }
                  }
                })
              } else {
                if (ans[0] == anstype.ansChoicetypeId) {
                  number = this.number
                  this.getresult(this.result, this.ques).resultIsSkipped = true
                  this.getresult(this.result, this.ques).resultAnswerValue = ''
                  for (var qs = id; qs < this.result.length; qs++) {
                    this.result[qs].resultAnswerValue = ''
                    this.result[qs].InnerResult = [];
                    this.result[qs].multiResult = [];
                    this.result[qs].resultAnswerId = 0
                    this.result[qs].resultChoicetypeId = 0
                    this.result[qs].resultScoreValue = ''
                  }
                }
              }

            }
          }
        }
      }
    }
    var showloader = true;
    ////console.log(p.value);
    if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
      this.getresult(this.result, this.ques).resultAnswerId = anstype.scoreId ? anstype.scoreId : 0
      if (num == 1065 || num == 1225 || num == 806) {
        if (this.CurrentUser.item.language != 'en_uk')
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.height + ' feet ' + p.value.feet + ' inches'
        else
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.height + ' m ' + p.value.feet + ' cm'
      }
      else if (num == 1066 || num == 1226 || num == 807) {
        if (this.CurrentUser.item.language != 'en_uk')
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.input + ' lbs'
        else
          this.getresult(this.result, this.ques).resultAnswerValue = p.value.input + ' kg'
      } else if ((this.ques.questiontype.toLowerCase()) == 'datetime') {
        if (p.value.input && p.value.input != 'Invalid Date') {
          p.value.input = this.datepipe.transform(this.changeFormatToDate(p.value.input), 'yyyy-MM-dd');
          p.value.input = p.value.input.toString()
        }
        this.getresult(this.result, this.ques).resultAnswerValue = p.value.input
      }
      else
        this.getresult(this.result, this.ques).resultAnswerValue = p.value.input
      this.getresult(this.result, this.ques).resultScoreValue = anstype.score_value
      this.getresult(this.result, this.ques).resultIsSkipped = false
    }
    if (this.name.type != 2) {
      this.userService
        .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
        .subscribe(
          data => {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          }

        );
    }


    if (number >= this.number) {
      this.complete = true;
      this.completesurvey(popup)
    }
    else {
      id = id + 1;

      for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
        var value = false;
        if (this.ques.quesion = "<b>Home Environment:  Interior</b>:<br>How many stairs are in your home that you need to climb?") {

          if (p.value.input == "" || p.value.input == "No" || p.value.input == "no" || p.value.input == "0" || p.value.input == "Zero" || p.value.input == "ZERO") {
            value = true;
          }
        }

        if ((anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) || !value) {
          this.ans = [];
          this.ques = [];
          this.intro = null;
          if (id == this.survey[0].survey.sQuestion[j].qNumber) {
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            //////console.log(this.ansvalue)
            let input, answer;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }

            this.inputsurvey = input; ////console.log(this.inputsurvey)
            //////console.log(this.inputsurvey)

            break;
          }
        }
        else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {
          let forwardid = this.ques.questionId + 1
          for (var t = 0; t < this.result.length; t++) {
            if (this.result[t].resultQuestionId == forwardid) {
              this.result[t].resultIsSkipped = true
              this.result[t].resultAnswerValue = ''
              forwardid = forwardid + 1
            }
            if (anstype.ForwardSkipQusId == forwardid) {
              //var temp = t;
              break;
            }

          }
          this.ans = [];
          this.ques = [];
          this.intro = null;
          this.ques = this.survey[0].survey.sQuestion[j];
          if ((this.ques.questiontype.toLowerCase()) == 'single')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
            this.padding = '13px'
          else
            this.padding = '68px'
          this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
          if (this.ans.innerChoice) {
            this.inner = this.ans.innerChoice
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
          }
          this.ansvalue = this.getresult(this.result, this.ques);
          if ((this.ques.questiontype.toLowerCase()) == 'single') {
            this.complete = false
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          let input = {
            'input': this.ansvalue.resultAnswerValue
          }
          this.inputsurvey = input; ////console.log(this.inputsurvey)
          //////console.log(this.inputsurvey)
          break;
        }
        if (number + 1 >= this.number)
          this.complete = true;
      }



    }


  }
  mulques(anstype, m, innerchoice, event) {
    this.option = false

    if (event.target.checked) {
      //////console.log(anstype.ansChoicetypeId)

      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        if (anstype.choicetype == this.userService.translateText('hospital_portal.profile.none.label') || anstype.choicetype == 'I did not experience any of these complications') {
          for (var jlen = 0; jlen < this.getresult(this.result, this.ques).multiResult.length; jlen++) {
            this.getresult(this.result, this.ques).multiResult[jlen].mulAnswerValue = "null"
            this.getresult(this.result, this.ques).multiResult[jlen].mulChoicetypeId = 0
            this.getresult(this.result, this.ques).multiResult[jlen].mulScoreValue = "null"
          }
          this.getresult(this.result, this.ques).multiResult[m].mulAnswerValue = anstype.choicetype
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = anstype.ansChoicetypeId
          this.getresult(this.result, this.ques).multiResult[m].mulScoreValue = anstype.score_value
          var result = this.getresult(this.result, this.ques)
          this.getresult(this.result, this.ques).resultIsSkipped = false

        }
        else {
          for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
            if (this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == this.userService.translateText('hospital_portal.profile.none.label') || this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue == "I did not experience any of these complications") {
              this.getresult(this.result, this.ques).multiResult[j].mulAnswerValue = "null"
              this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId = 0
              this.getresult(this.result, this.ques).multiResult[j].mulScoreValue = "null"
            }
          }
          this.getresult(this.result, this.ques).multiResult[m].mulAnswerValue = anstype.choicetype
          this.getresult(this.result, this.ques).multiResult[m].mulChoicetypeId = anstype.ansChoicetypeId
          this.getresult(this.result, this.ques).multiResult[m].mulScoreValue = anstype.score_value
          this.getresult(this.result, this.ques).resultIsSkipped = false

        }
        if (!anstype.innerChoice) {
          for (var s = 0; s < this.getresult(this.result, this.ques).InnerResult.length; s++) {
            this.getresult(this.result, this.ques).InnerResult[s].innerAnswerValue = "null"
          }
        }
      }



      if (anstype.innerChoice) {
        this.inner = anstype.innerChoice
        this.anstype = anstype
        if (result.InnerResult[0]) {
          this.inneransvalue = result.InnerResult
          // Initialize enableques to false by default
          this.enableques = false
          // Initialize innerAnswerValue as object for textbox types
          for (let i = 0; i < this.inneransvalue.length; i++) {
            if (this.inner[i] && this.inner[i].innerQuestionType && this.inner[i].innerQuestionType.toLowerCase() === 'textbox') {
              if (typeof this.inneransvalue[i].innerAnswerValue === 'string' && (this.inneransvalue[i].innerAnswerValue === 'null' || this.inneransvalue[i].innerAnswerValue === '')) {
                this.inneransvalue[i].innerAnswerValue = {}
              } else if (typeof this.inneransvalue[i].innerAnswerValue === 'string') {
                // Try to parse if it's a JSON string
                try {
                  this.inneransvalue[i].innerAnswerValue = JSON.parse(this.inneransvalue[i].innerAnswerValue)
                } catch (e) {
                  this.inneransvalue[i].innerAnswerValue = {}
                }
              }
            }
            
            // Initialize enableques based on existing answers for conditional questions
            if (this.inner[i + 1] && (this.inner[i + 1].innerChoicePk == 25 || this.inner[i + 1].innerChoicePk == 28 || this.inner[i + 1].innerChoicePk == 31 || this.inner[i + 1].innerChoicePk == 34)) {
              const currentAnswer = this.inneransvalue[i].innerAnswerValue;
              if (typeof currentAnswer === 'string' && currentAnswer.toLowerCase() === this.userService.translateText('hospital_portal.mytodos.yes_small.label')) {
                this.enableques = true
              }
            }
          }
        }
        //////console.log(this.inner)

        this.modalRef = this.modalService.show(innerchoice, { backdrop: 'static' });
        this.movable() 
      }
    }
    else if ((!event.target.checked)) {
      for (var jle = 0; jle < this.getresult(this.result, this.ques).multiResult.length; jle++) {
        if (anstype.ansChoicetypeId == this.getresult(this.result, this.ques).multiResult[jle].mulChoicetypeId) {
          this.getresult(this.result, this.ques).multiResult[jle].mulAnswerValue = "null"
          this.getresult(this.result, this.ques).multiResult[jle].mulChoicetypeId = 0
          this.getresult(this.result, this.ques).multiResult[jle].mulScoreValue = "null"
        }
      }

    }

  }
  nextmulques(id, popup: TemplateRef<any>) {
    this.mulans = false
    this.option = false
    var ans;
    for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
      if (this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId != 0) {
        this.mulans = true;
      }

    }
    if (this.mulans) {
      let number: string = id;
      //let num: number = this.ques.questionId;


      ////////console.log(this.answer);



      ////////console.log(this.result)
      ////////console.log(number)
      if (this.name.type != 2) {
        this.userService
          .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
          .subscribe(
            data => {
              this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
            }

          );
      }
      if (number >= this.number) {
        this.complete = true;
        this.completesurvey(popup);

      }
      else {
        id = id + 1;


        for (var jq = 0; jq < this.survey[0].survey.sQuestion.length; jq++) {

          for (var l = 0; l < this.ans.length; l++) {
            if (this.ans[l].ForwardSkipQusId != null) {

              ans = this.ans[l].ForwardSkipQusId
            }
          }
          if (ans == "" || !ans) {
            if (id == this.survey[0].survey.sQuestion[jq].qNumber) {
              this.ans = [];
              this.ques = [];
              this.intro = null;
              this.ques = this.survey[0].survey.sQuestion[jq];
              if ((this.ques.questiontype.toLowerCase()) == 'single')
                this.complete = false
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
                this.complete = false
              this.mulans = null;
              if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
                this.padding = '13px'
              else
                this.padding = '68px'
              this.ans = [];
              this.ans = this.survey[0].survey.sQuestion[jq].sAnswer;
              if (this.ans.innerChoice) {
                this.inner = this.ans.innerChoice
              }
              this.ansvalue = this.getresult(this.result, this.ques);
              if ((this.ques.questiontype.toLowerCase()) == 'single') {
                this.complete = false
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
                if (this.ansvalue.resultChoicetypeId != 0)
                  this.option = true
              }
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
              let input, answer;
              if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'height': answer[0],
                    'feet': answer[2]
                  }
                }
                else {
                  input = {
                    'height': '',
                    'feet': ''
                  }
                }
              }
              else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

                if (this.ansvalue.resultAnswerValue != 'null') {
                  answer = this.ansvalue.resultAnswerValue.split(' ');
                  input = {
                    'input': answer[0]
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              else {
                if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                  input = {
                    'input': this.ansvalue.resultAnswerValue
                  }
                } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                  input = {
                    'input': new Date(this.ansvalue.resultAnswerValue)
                  }
                }
                else {
                  input = {
                    'input': ''
                  }
                }
              }
              this.inputsurvey = input; ////console.log(this.inputsurvey)
              break;
            }
          }
          else if (ans == this.survey[0].survey.sQuestion[jq].questionId) {
            let forwardid = this.ques.questionId + 1
            for (var t = 0; t < this.result.length; t++) {
              if (this.result[t].resultQuestionId == forwardid) {
                this.result[t].resultIsSkipped = true
                this.result[t].resultAnswerValue = ''
                forwardid = forwardid + 1
              }
              if (ans == forwardid) {
                //var temp = t;
                break;
              }


            }
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[jq];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = [];
            this.ans = this.survey[0].survey.sQuestion[jq].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
              this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input, answer;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; ////console.log(this.inputsurvey)
            break;
          }
          if (number + 1 >= this.number)
            this.complete = true;


        }

      }
    }
    else {
      this.toastr.toastrConfig.timeOut = this.timeset;
      this.toastr.warning(this.userService.translateText('patient_portal.display_messages.please_select_any_one.error'));
    }

  }
  slidevalue(event: any) {
    this.slideval = event.value
  }
  nextslideques(id, anstype, event, popup: TemplateRef<any>) {
    this.option = false
    let number: string = id;
    //let num: number = this.ques.questionId
    //////console.log(number)
    ////////console.log(this.result)
    this.answer[id] = anstype
    if (event == undefined) {
      event = 0;
    }
    ////////console.log(this.answer);
    if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
      this.getresult(this.result, this.ques).resultAnswerValue = event
      this.getresult(this.result, this.ques).resultChoicetypeId = anstype.ansChoicetypeId
      this.getresult(this.result, this.ques).resultIsSkipped = false
    }
    ////////console.log(this.result)

    ////////console.log(number)
    if (this.name.type != 2) {
      this.userService
        .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
        .subscribe(
          data => {
            this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          }

        );
    }
    if (number >= this.number) {
      this.complete = true;
      this.completesurvey(popup);
    }
    else {
      id = id + 1;
      ////////console.log(anstype);
      this.ansvalue = null
      for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {





        if (anstype.ForwardSkipQusId == "" || !anstype.ForwardSkipQusId) {
          if (id == this.survey[0].survey.sQuestion[j].qNumber) {
            this.ans = [];
            this.ques = [];
            this.intro = null;
            this.ques = this.survey[0].survey.sQuestion[j];
            if ((this.ques.questiontype.toLowerCase()) == 'single')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
              this.complete = false
            if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
              this.padding = '13px'
            else
              this.padding = '68px'
            this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
            if (this.ans.innerChoice) {
              this.inner = this.ans.innerChoice
            }
            this.ansvalue = this.getresult(this.result, this.ques);
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
            if ((this.ques.questiontype.toLowerCase()) == 'single') {
              this.complete = false
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
              if (this.ansvalue.resultChoicetypeId != 0)
                this.option = true
            }
            let input, answer;
            if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'height': answer[0],
                  'feet': answer[2]
                }
              }
              else {
                input = {
                  'height': '',
                  'feet': ''
                }
              }
            }
            else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

              if (this.ansvalue.resultAnswerValue != 'null') {
                answer = this.ansvalue.resultAnswerValue.split(' ');
                input = {
                  'input': answer[0]
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            else {
              if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
                input = {
                  'input': this.ansvalue.resultAnswerValue
                }
              } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
                input = {
                  'input': new Date(this.ansvalue.resultAnswerValue)
                }
              }
              else {
                input = {
                  'input': ''
                }
              }
            }
            this.inputsurvey = input; ////console.log(this.inputsurvey)
            break;
          }
        }
        else if (anstype.ForwardSkipQusId == this.survey[0].survey.sQuestion[j].questionId) {
          let forwardid = this.ques.questionId + 1
          for (var t = 0; t < this.result.length; t++) {
            if (this.result[t].resultQuestionId == forwardid) {
              this.result[t].resultIsSkipped = true
              this.result[t].resultAnswerValue = ''
              forwardid = forwardid + 1
            }
            if (anstype.ForwardSkipQusId == forwardid) {
              //var temp = t
              break;
            }

          }
          this.ans = [];
          this.ques = [];
          this.intro = null;
          this.ques = this.survey[0].survey.sQuestion[j];
          if ((this.ques.questiontype.toLowerCase()) == 'single')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
            this.complete = false
          if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
            this.padding = '13px'
          else
            this.padding = '68px'
          this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
          if (this.ans.innerChoice) {
            this.inner = this.ans.innerChoice
            this.inneransvalue = this.getresult(this.result, this.ques).InnerResult;
          }
          this.ansvalue = this.getresult(this.result, this.ques);
          if ((this.ques.questiontype.toLowerCase()) == 'single') {
            this.complete = false
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
            if (this.ansvalue.resultChoicetypeId != 0)
              this.option = true
          }
          let input, answer;
          if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'height': answer[0],
                'feet': answer[2]
              }
            }
            else {
              input = {
                'height': '',
                'feet': ''
              }
            }
          }
          else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

            if (this.ansvalue.resultAnswerValue != 'null') {
              answer = this.ansvalue.resultAnswerValue.split(' ');
              input = {
                'input': answer[0]
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          else {
            if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
              input = {
                'input': this.ansvalue.resultAnswerValue
              }
            } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
              input = {
                'input': new Date(this.ansvalue.resultAnswerValue)
              }
            }
            else {
              input = {
                'input': ''
              }
            }
          }
          this.inputsurvey = input; ////console.log(this.inputsurvey)
          break;
        }
        if (number + 1 >= this.number)
          this.complete = true;


      }
    }
  }
  preques(id) {
    this.option = false
    //let number: string = id;
    id = id - 1;
    //////console.log(id)
    //////console.log(this.result)
    for (var jw = 0; jw < this.survey[0].survey.sQuestion.length; jw++) {
      for (var m = 0; m < this.survey[0].survey.sQuestion[jw].sAnswer.length; m++) {
        if (this.ques.questionId == this.survey[0].survey.sQuestion[jw].sAnswer[m].ForwardSkipQusId) {
          id = jw + 1
          break;

        }
      }
    }
    this.complete = false;
    let index = _.findIndex(this.survey[0].survey.sQuestion, (o: any): any => {
      return o.qNumber == id
    })
    if (index != -1) {
      this.ansvalue = this.getresult(this.result, this.survey[0].survey.sQuestion[index]);
      if (this.getresult(this.result, this.survey[0].survey.sQuestion[index]).InnerResult[0]) {
        this.inneransvalue = this.getresult(this.result, this.survey[0].survey.sQuestion[index]).InnerResult;
      }
    }
    //////console.log(this.ansvalue)
    for (var j = 0; j < this.survey[0].survey.sQuestion.length; j++) {
      this.intro = null;
      if (id == this.survey[0].survey.sQuestion[j].qNumber && !this.getresult(this.result, this.ques).resultIsSkipped) {
        this.ques = this.survey[0].survey.sQuestion[j];
        this.ans = this.survey[0].survey.sQuestion[j].sAnswer;
        if ((this.ques.questiontype.toLowerCase()) == 'single')
          this.complete = false
        if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn')
          this.complete = false
        if ((this.ques.questiontype.toLowerCase()) == 'multiplercsd' || (this.ques.questiontype.toLowerCase()) == 'multiple')
          this.padding = '13px'
        else
          this.padding = '68px'
        if ((this.ques.questiontype.toLowerCase()) == 'single') {
          this.complete = false
          if (this.ansvalue.resultChoicetypeId != 0)
            this.option = true
        }
        if ((this.ques.questiontype.toLowerCase()) == 'singlenewyn') {
          if (this.ansvalue.resultChoicetypeId != 0)
            this.option = true
        }
        let input, answer;
        if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1065 || this.ques.questionId == 1225 || this.ques.questionId == 806)) {

          if (this.ansvalue.resultAnswerValue != 'null') {
            answer = this.ansvalue.resultAnswerValue.split(' ');
            input = {
              'height': answer[0],
              'feet': answer[2]
            }
          }
          else {
            input = {
              'height': '',
              'feet': ''
            }
          }
        }
        else if ((this.ques.questiontype.toLowerCase()) == 'textbox' && (this.ques.questionId == 1066 || this.ques.questionId == 1226 || this.ques.questionId == 807)) {

          if (this.ansvalue.resultAnswerValue != 'null') {
            answer = this.ansvalue.resultAnswerValue.split(' ');
            input = {
              'input': answer[0]
            }
          }
          else {
            input = {
              'input': ''
            }
          }
        }
        else {
          if (this.ansvalue.resultAnswerValue != 'null' && this.ques.questiontype.toLowerCase() != 'datetime') {
            input = {
              'input': this.ansvalue.resultAnswerValue
            }
          } else if (this.ques.questiontype.toLowerCase() == 'datetime' && this.ansvalue.resultAnswerValue != 'null') {
            input = {
              'input': new Date(this.ansvalue.resultAnswerValue)
            }
          }
          else {
            input = {
              'input': ''
            }
          }
        }
        this.inputsurvey = input; ////console.log(this.inputsurvey)
        break;
      }






    }

  }
  completesurvey(popup: TemplateRef<any>) {
    this.enable = true;
    this.enablepage = false;
    let mode = 'C'
    if (this.name.type != 2) {
      this.userService.partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart).subscribe(data => { });
    }
    this.userService
      .postsurvey(this.surveyques, this.result, this.name.swfid, mode, this.name.type)
      .subscribe(
        data => {
          if (data.item.status == "success") {
            this.savesurvey = data.item.message;
            this.toastr.toastrConfig.timeOut = this.timeset;
            this.toastr.success(data.item.message);
            this.userService.logAudit("savesurveyresult", 0).subscribe(data => { })
            this.router.navigateByUrl(`/care/patientsummary`)
          }
          else if (data.item.status == "failure") {
            this.savesurvey = data.item.message;
            this.toastr.toastrConfig.timeOut = this.timeset;
            this.toastr.error(data.item.message)
            this.router.navigateByUrl(`/care/patientsummary`)
          }
          /* this.modalRef = this.modalService.show(popup, { class: 'modal-sm' }); */

        }

      );
  }
  getmin(ansty) {
    if (ansty) {
      let arrlen = ansty.choicetype.split(',')
      return arrlen[0]
    }
  }
  getmax(anstype) {
    if (anstype) {
      let arr = anstype.choicetype.split(',')
      return arr[1]
    }
  }
  gettypetext(id) {
    if (id == 536) {
      return false
    }
    else {
      return true
    }

  }
  dateValueChange(event) {
    if (event.keyCode != 8) {
      if (event.target.value.length == 2 || event.target.value.length == 5) {
        var thisVal = event.target.value;
        thisVal += '/';
        event.target.value = thisVal;
      }
    }
  }

  checkempty(id) {
    let date
    ////console.log(id)
    if (id != 'Invalid Date')
      date = this.datepipe.transform(id, 'yyyy-MM-dd');
    let curentdate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    if (id == '' || id == null || id == 'Invalid Date') {
      this.showinvaild = true
      this.inputsurvey.input = ''
    } else if (id != '' && id != null && date > curentdate) {
      this.maxdate = true;
      this.showinvaild = false;
    } else {
      this.showinvaild = false;
      this.maxdate = false;
    }
  }
  saveData(number, popup) {
    this.userService
      .partialsurvey(this.name.name, this.result, this.name.swfid, this.survey[0].survey.surveyPart)
      .subscribe(
        data => {
          this.userService.logAudit("savepartialsurveyresult", 0).subscribe(data => { })
          if (data) {
            if (number >= this.number) {
              this.complete = true;
              this.completesurvey(popup)
            }
            else {
              this.router.navigateByUrl(`/care/patientsummary`)
            }
          }
        }
      );
  }
  saveExit(popup) {
    let self = this;
    let number: string = self.ques.qNumber;
    if (self.ques.questiontype.toLowerCase() == 'single' && this.name.patedit == 'new') {
      if (this.getresult(this.result, this.ques).resultChoicetypeId != 0) {
        this.saveData(number, popup)
      } else {
        this.router.navigateByUrl(`/care/patientsummary`)
      }
    } else if (self.ques.questiontype.toLowerCase() == 'singlenewyn' && this.name.patedit == 'new') {
      this.option = false
      this.mulans = false;
      let index = _.findIndex(this.getresult(this.result, this.ques).multiResult, (o: any): any => {
        return o.mulAnswerValue == "null"
      })
      if (index == -1) {
        let number: string = self.ques.qNumber;
        //let num: number = this.ques.questionId;
        this.saveData(number, popup)

      } else {
        this.router.navigateByUrl(`/care/patientsummary`)
      }
    }
    else if ((self.ques.questiontype.toLowerCase() == 'multiplerscd' || self.ques.questiontype.toLowerCase() == 'multiple') && this.name.patedit == 'new') {
      this.option = false
      for (var j = 0; j < this.getresult(this.result, this.ques).multiResult.length; j++) {
        if (this.getresult(this.result, this.ques).multiResult[j].mulChoicetypeId != 0) {
          this.mulans = true;
        }
      }
      if (this.mulans) {
        let number: string = self.ques.qNumber;
        //let num: number = this.ques.questionId;
        this.saveData(number, popup)
      } else {
        this.router.navigateByUrl(`/care/patientsummary`)
      }

    } else if ((self.ques.questiontype.toLowerCase() == 'sliderbar' || self.ques.questiontype.toLowerCase() == 'c_sliderbar' || self.ques.questiontype.toLowerCase() == 'slider') && this.name.patedit == 'new') {
      this.option = false
      let number: string = self.ques.qNumber;
      //let num: number = this.ques.questionId
      if (self.slideval == undefined) {
        self.slideval = 0;
      }
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).resultAnswerValue = self.slideval
        this.getresult(this.result, this.ques).resultChoicetypeId = self.ans[0].ansChoicetypeId
        this.getresult(this.result, this.ques).resultIsSkipped = false
      }
      this.saveData(number, popup)
    } else if ((self.ques.questiontype.toLowerCase() == 'textbox') && this.name.patedit == 'new') {
      this.option = false
      let num: number = this.ques.questionId;
      var showloader = true;
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        if (this.inputsurvey.height && this.inputsurvey.feet && !this.inputsurvey.input || this.inputsurvey.input) {
          this.getresult(this.result, this.ques).resultAnswerId = this.ans[0].scoreId ? this.ans[0].scoreId : 0
          if (num == 1065 || num == 1225 || num == 806) {
            if (this.CurrentUser.item.language != 'en_uk')
              this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.height + ' feet ' + this.inputsurvey.feet + ' inches'
            else
              this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.height + ' m ' + this.inputsurvey.feet + ' cm'
          }
          else if (num == 1066 || num == 1226 || num == 807) {
            if (this.CurrentUser.item.language != 'en_uk') {
              if (Number(this.inputsurvey.input) <= 500)
                this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input + ' lbs'
            }
            else
              this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input + ' kg'
          }
          else
            this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input
          this.getresult(this.result, this.ques).resultScoreValue = this.ans[0].score_value
          this.getresult(this.result, this.ques).resultIsSkipped = false
        } else {
          this.inputsurvey.height = ''
          this.inputsurvey.feet = ''
          this.inputsurvey.input = ''
        }
      }
      this.saveData(number, popup)
    }
    else if ((self.ques.questiontype.toLowerCase() == 'datetime') && this.name.patedit == 'new') {
      this.option = false
      //let num: number = this.ques.questionId;
      //var showloader = true;
      if (this.inputsurvey.input && this.inputsurvey.input != 'Invalid Date')
        this.inputsurvey.input = this.datepipe.transform(this.changeFormatToDate(this.inputsurvey.input), 'yyyy-MM-dd');
      if (this.getresult(this.result, this.ques).resultQuestionId == this.ques.questionId) {
        this.getresult(this.result, this.ques).resultAnswerId = this.ans[0].scoreId ? this.ans[0].scoreId : 0
        this.getresult(this.result, this.ques).resultAnswerValue = this.inputsurvey.input
        this.getresult(this.result, this.ques).resultScoreValue = this.ans[0].score_value
        this.getresult(this.result, this.ques).resultIsSkipped = false
      }
      if (this.name.patedit == 'new') {
        this.saveData(number, popup)
      }
      else {
        this.completesurvey(popup)
      }
    } else {
      this.completesurvey(popup)
    }

  }
  movable() {
    $(function () {
      let modalContent: any = $('.modal-content');
      let modalHeader = $('.modal-header');
      modalHeader.addClass('cursor-all-scroll');
      modalContent.draggable({
        handle: '.modal-header'
      });
    });
  }
  surveydownloadurl: any = environment.surveydownloadUrl;
  onPrint() {
    let printContents;
    let data: any = {
      preview: true,
      hspPatSurveyId: this.name.name,
      patientSwfId: this.name.swfid,
      lang: this.userService.selectedLang()
    }
    data = this.userService.encrypt(JSON.stringify(data))
    data = btoa(data)
    printContents = this.surveydownloadurl + data
    ////console.log(printContents)
    window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
  }
  getresult(result, ques) {
    let index = _.findIndex(result, (o: any): any => {
      return o.resultQuestionId.toString() == ques.questionId.toString()
    })
    if (index != -1) {
      return result[index]
    } else {
      return ''
    }
  }
  changeFormatToDate(dateString) {
    var changedFormat;
    if (this.CurrentUser.item.language == 'en_uk' && (typeof dateString == 'string' || dateString instanceof String)) {
      var splitDate1 = dateString.split('/');
      if (splitDate1.length > 1) {
        var day1 = splitDate1[0];
        var month1 = splitDate1[1];
        var year1 = splitDate1[2];
        changedFormat = month1 + "/" + day1 + "/" + year1;
        return changedFormat
      } else {
        var date: any = dateString
        return new Date(date)
      }
    } else {
      return new Date(dateString)
    }
  }
  createRange(number) {
    var items: number[] = [];
    for (var i = 1; i <= number; i++) {
      items.push(i);
    }
    return items;
  }


  getName(name) {
    if (name) {
      let title = name.toLowerCase()
      if (title.search('pain') != -1) {
        return true
      } else
        return false
    } else {
      return false
    }
  }
  getValueType(ques) {
    if (ques.valueType && ques.valueType == 'NUMERIC') {
      return true
    }
    return false
  }
  getValueLength(ques) {
    if (ques.valueLength) {
      return ques.valueLength
    }
    return 200
  }

  checkBoxTickManual(id) {
    document.getElementById(id).click()
  }

  sliderOption(anstype) {
    let options: Options = {
      floor: 0,
      ceil: this.getmax(anstype),
      step: 1,
      minRange: this.getmin(anstype),
      maxRange: this.getmax(anstype),
      showTicks: true,
      getLegend: (value: number): any => {
        return value;
      }
    };
    return options
  }

  getInnerChoiceValue(inneransvalue, innerAnsChName) {
    if(inneransvalue && ((typeof inneransvalue == 'string' && inneransvalue != 'null') || typeof inneransvalue == 'number')) return inneransvalue;
    else if(Object.keys(inneransvalue).length > 0 && inneransvalue[innerAnsChName] != null) return Number(inneransvalue[innerAnsChName]);
    return '';
  }
}
